import Vue from 'vue'
import Router from 'vue-router'
import { kkrenMemberUrl, isKkrenMemberPath } from '@g/site/kkrenNavigation'

// 仅为原登录组件提供 query、命名路由解析和回跳，不加载会员组件或运行会员守卫。
// 所有实际导航均整页进入 /app/；router-link 的 href 同样指向会员 HTML。
export function createHomepageRouter () {
  Vue.use(Router)
  const router = new Router({
    mode: 'abstract',
    routes: [
      { name: 'Login', path: '/login' },
      { name: 'Home', path: '/' },
      { name: 'Parcel', path: '/parcel' },
      { name: 'About', path: '/about' },
      { name: 'HomeCalendar', path: '/home/calendar' },
      { name: 'HomeAddress', path: '/home/address' },
      { name: 'SuspendPost', path: '/suspendPost' },
      { name: 'PostDetail', path: '/post/detail/:poid' },
    ],
  })
  router.replace('/login' + window.location.search)
  const resolve = router.resolve.bind(router)
  router.resolve = (...args) => {
    const result = resolve(...args)
    return { ...result, href: kkrenMemberUrl(result.route.fullPath) }
  }
  const navigate = (target, replace) => {
    // 新设备验证、找回密码、注册等走 Home/Parcel 时也接手已有的登录回跳。
    const saved = sessionStorage.getItem('redirect')
    const isDefault = target && ['Home', 'Parcel'].includes(target.name)
    const route = resolve(isKkrenMemberPath(saved) && isDefault ? saved : target).route
    const url = kkrenMemberUrl(route.fullPath)
    if (isDefault || (saved && target && target.path === saved)) sessionStorage.removeItem('redirect')
    window.location[replace ? 'replace' : 'assign'](url)
    return Promise.resolve(route)
  }
  router.push = target => navigate(target, false)
  router.replace = target => navigate(target, true)
  return router
}
